const AllTeams = () => import("../team/views/AllTeams.vue");
const TeamForm = () => import("../team/views/TeamForm.vue");
const EditTeam = () => import("../team/views/EditTeam.vue");

export default [
  {
    path: "view-all",
    component: AllTeams,
  },
  {
    path: "edit/:id",
    component: EditTeam,
  },
  {
    path: "create",
    component: TeamForm,
  },
];
